import React from 'react';
import { Download } from 'lucide-react';
import PageContainer from 'ui/PageContainer';
import PageHeader from 'ui/PageHeader';
import Tabs, { Tab } from 'ui/Tabs';
import DownloadLogPanel from './DownloadLogPanel';

/**
 * 보안 — 이용 이력과 접근 기록을 모아 보는 화면.
 * 지금은 다운로드 로그 하나이고, 열람·출력 이력 등이 생기면 탭으로 추가한다.
 */
const SecurityPage: React.FC = () => {
    const tabs: Tab[] = [
        {
            id: 'download-logs',
            label: '다운로드 로그',
            icon: <Download />,
            content: <DownloadLogPanel />,
        },
    ];

    return (
        <PageContainer>
            <PageHeader
                title="보안"
                subtitle="자료 이용 이력과 접속 기록을 확인합니다."
            />
            <Tabs tabs={tabs} defaultTab="download-logs" />
        </PageContainer>
    );
};

export default SecurityPage;
